import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { createRef } from 'react';
import { getInitialViewportSize, addResizeCallback, removeResizeCallback, getViewportSize } from '../../utils/windowEvents/ResizeEvents.js';
import { StagePresentation } from './StagePresentation.js';

var StageWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(StageWrapper, _React$Component);

  var _super = _createSuper(StageWrapper);

  function StageWrapper(props) {
    var _this;

    _classCallCheck(this, StageWrapper);

    _this = _super.call(this, props);
    _this.layoutRegularRef = /*#__PURE__*/createRef();
    _this.layoutBreakingRef = /*#__PURE__*/createRef();
    _this.hostRef = /*#__PURE__*/createRef();
    _this.scrollerRef = /*#__PURE__*/createRef();
    _this.eyeCatcherRef = /*#__PURE__*/createRef();

    _this.scrollStageHeight = function () {
      window.scrollBy({
        top: window.innerHeight,
        left: 0,
        behavior: "smooth"
      });
    };

    _this.state = {
      viewport: getInitialViewportSize(),
      hideEyeCatcher: true,
      eyeCatcherDefaultAppearanceTime: props.eyeCatcherAppearanceTime || 3000,
      layout: "regular",
      eyeCatcherPosition: {
        top: "auto",
        right: 0,
        bottom: "auto",
        left: "auto"
      }
    };
    return _this;
  }

  _createClass(StageWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // needs to be done after constructor, so that the stage is initially rendered the same way as the server
      this.doHandleResizeWindow = this.doHandleResizeWindow.bind(this);
      addResizeCallback(this.doHandleResizeWindow);
      this.timeout = setTimeout(function () {
        return _this2.setState({
          hideEyeCatcher: false
        });
      }, this.state.eyeCatcherDefaultAppearanceTime);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      removeResizeCallback(this.doHandleResizeWindow);
      clearTimeout(this.timeout);
    }
  }, {
    key: "doHandleResizeWindow",
    value: function doHandleResizeWindow() {
      if (typeof window === "undefined") {
        return;
      }

      var viewport = getViewportSize();
      var windowHeight = window.innerHeight;
      var headerHeight = this.hostRef.current.offsetTop - this.hostRef.current.parentElement.offsetTop;
      var stageHeight = windowHeight - headerHeight;
      var regularLayoutHeight = this.layoutRegularRef.current !== null ? this.layoutRegularRef.current.clientHeight : 0;
      var breakingLayoutHeight = this.layoutBreakingRef.current !== null ? this.layoutBreakingRef.current.clientHeight : 0;
      var maxHeight = {
        md: 70,
        lg: 70,
        xl: 55
      }[viewport] || 60;
      var layout = "regular";

      if (regularLayoutHeight * 100 / stageHeight > maxHeight) {
        layout = "breaking";

        if (breakingLayoutHeight * 100 / stageHeight > maxHeight) {
          layout = "breaking-full";
        }
      } // TODO calculate fallback value


      var contentHeight = layout === "regular" && regularLayoutHeight || layout === "breaking" && breakingLayoutHeight || 100;
      var stageWidth = window.innerWidth;
      var contentWidth = this.layoutBreakingRef.current !== null ? this.layoutBreakingRef.current.clientWidth : 0;
      var eyeCatcherHeight = this.eyeCatcherRef.current !== null ? this.eyeCatcherRef.current.clientHeight : 0;
      var eyeCatcherWidth = this.eyeCatcherRef.current !== null ? this.eyeCatcherRef.current.clientWidth : 0;
      var gridColumnWidth = contentWidth / 12;
      var scrollerHeight = this.scrollerRef.current !== null ? this.scrollerRef.current.clientHeight : 0; // Set eyeCatcherRight

      var eyeCatcherRight = 16;

      if (viewport === "xl") {
        eyeCatcherRight = gridColumnWidth - eyeCatcherWidth;

        if ((stageWidth - contentWidth) / 2 < eyeCatcherWidth) {
          eyeCatcherRight = -32;
        }
      }

      if (viewport === "lg") {
        eyeCatcherRight = gridColumnWidth - eyeCatcherWidth + 16;

        if ((stageWidth - contentWidth) / 2 < eyeCatcherWidth) {
          eyeCatcherRight = -32;
        }
      } // set eyeCatcherTop
      // TODO: get margin top and margin bottom dynamically


      var eyeCatcherTop = 0;

      if (eyeCatcherHeight + contentHeight + scrollerHeight + 64 < stageHeight) {
        eyeCatcherTop = 32;
      }

      this.setState({
        eyeCatcherPosition: {
          top: eyeCatcherTop !== 0 ? "auto" : 32,
          right: eyeCatcherRight,
          bottom: eyeCatcherTop !== 0 ? contentHeight : "auto",
          left: "auto"
        },
        layout: layout
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(StagePresentation, Object.assign({}, this.props, {
        hideEyeCatcher: this.state.hideEyeCatcher,
        viewport: this.state.viewport,
        layoutRegularRef: this.layoutRegularRef,
        layoutBreakingRef: this.layoutBreakingRef,
        hostRef: this.hostRef,
        scrollerRef: this.scrollerRef,
        layout: this.state.layout,
        eyeCatcherPosition: this.state.eyeCatcherPosition,
        eyeCatcherRef: this.eyeCatcherRef,
        onScrollerClick: this.scrollStageHeight
      }));
    }
  }]);

  return StageWrapper;
}(React.Component);

export { StageWrapper };
